export default {"src":"/_next/static/media/fix-hardscape.151e5b23.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};